// Shared PESO link/QR helpers. QR is rendered by a free external service (api.qrserver.com)
// so it adds no dependency; the encoded data is just a public registration URL.
export const QR_API = 'https://api.qrserver.com/v1/create-qr-code/';
// Canonical public domain (App.js redirects non-www -> www). Pinned so a copied link or a
// PRINTED QR always points to the live site, regardless of which host a staffer opens from.
export const PUBLIC_BASE_URL = 'https://www.boholtrabaho.com';

export async function downloadQr(url, file) {
  const api = `${QR_API}?size=1000x1000&margin=24&format=png&data=${encodeURIComponent(url)}`;
  const res = await fetch(api);
  if (!res.ok) throw new Error('qr');
  const blob = await res.blob();
  const obj = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = obj; a.download = file;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => window.URL.revokeObjectURL(obj), 1000);
}
